import { createTheme } from '@mui/material/styles';

export const defaultTheme = createTheme({
  direction: 'rtl',
  palette: {
    mode: 'light',
    primary: {
      main: '#199DA3',
      light: '#37AAAF',
      dark: '#16898E',
      lighter: '#75C4C8',
      darker: '#0F5E62',
      lightest: '#AADBDD',
      darkest: '#093A3C',
      contrastText: '#ffffff',
    },
    // secondary: {
    //   main: '#0c395a',
    //   light: '#3C607A',
    //   lighter: '#6C879B',
    //   moreLight: '#9CAEBB',
    //   veryLight: '#CCD5DC',
    //   veryVeryLight: '#E4E9EC',
    //   lightest: '#F7F8F9',
    //   contrastText: '#ffffff',
    // },
    secondary: {
      main: '#f16063',
      light: '#3C607A',
      lighter: '#6C879B',
      moreLight: '#9CAEBB',
      veryLight: '#CCD5DC',
      veryVeryLight: '#E4E9EC',
      lightest: '#F7F8F9',
      contrastText: '#ffffff',
    },
    elevaion: {
      background: '#FCFCFC',
      surface: '#FFFFFF',
      contrastText: '#222222',
    },
    annotation: {
      error: '#FF5630',
      success: '#36B37E',
      warning: '#FFAB00',
      contrastText: '#222222',
    },
    gray: {
      main: '#199DA3',
      darkest: '#333333',
      darker: '#454545',
      dark: '#777777',
      light: '#EEEEEE',
      lighter: '#F5F5F5',
      lightest: '#F9F9F9',
      contrastText: '#ffffff',
    },
    notification: {
      main: '#E1E8FF',
      error: '#FFE9D5',
      success: '#D8FBDE',
      warning: '#FFEBC3',
      notif: '#4C6FFF',
      contrastText: '#ffffff',
    },
    accent: {
      oceanBlue: '#008BF8',
      eggplantViolet: '#48284A',
      gedarGreen: '#849324',
      tangerine: '#FFB30F',
      persianGreen: '#72E1D1',
      tomatoRed: '#FD151B',
      pinkPanther: '#F896D8',
      candyBlue: '#008BF8',
      cherry: '#BF1A2F',
      skobeloff: '#0F7173',
      contrastText: '#ffffff',
    },
    naturals: {
      black: '#222222',
      white: '#FFFFFF',
    },
    contrastText: {
      light: '#ffffff',
      dark: '#222222',
    },
    text: {
      primary: '#222222',
    },
    default: {
      main: '#f16063',
    },
  },
  typography: {
    fontFamily: 'IranYekanNum',
    fontSize: '0.875rem',
    fontWeightThin: 200,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontWeightBolder: 800,
    fontWeightBoldest: 1000,
    title: {
      fontFamily: 'IranYekanNum',
      fontWeight: 800,
      fontSize: '1.5rem',
      lineHeight: '36px',
    },
    subtitleBold: {
      fontFamily: 'IranYekanNum',
      fontWeight: 800,
      fontSize: '1rem',
      lineHeight: '24px',
    },
    subtitle: {
      fontFamily: 'IranYekanNum',
      fontWeight: 700,
      fontSize: '1rem',
      lineHeight: '24px',
    },
    subtitle2: {
      fontFamily: 'IranYekanNum',
      fontWeight: 700,
      fontSize: '0.875rem',
      lineHeight: '24px',
    },
    bodyBold: {
      fontFamily: 'IranYekanNum',
      fontWeight: 700,
      fontSize: '0.875rem',
      lineHeight: '20px',
    },
    body: {
      fontFamily: 'IranYekanNum',
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '20px',
    },
    caption: {
      fontFamily: 'IranYekanNum',
      fontWeight: 700,
      fontSize: '0.75rem',
      lineHeight: '0.75rem',
    },
    captionLight: {
      fontFamily: 'IranYekanNum',
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: '24px',
    },
    button: {
      fontFamily: 'IranYekanNum',
      fontWeight: 700,
      fontSize: '0.75rem',
      lineHeight: '20px',
    },
    overline: {
      fontFamily: 'IranYekanNum',
      fontWeight: 400,
      fontSize: '0.625rem',
      lineHeight: '16px',
    },
  },
  breakpoints: {
    values: {
      xs: 400,
      xs0: 400,
      xs1: 450,
      xs2: 500,
      xs3: 550,
      sm: 600,
      sm0: 600,
      sm1: 650,
      sm2: 700,
      sm3: 750,
      sm4: 800,
      sm5: 850,
      md: 900,
      md0: 900,
      md1: 950,
      md2: 1000,
      md3: 1050,
      md4: 1100,
      md5: 1150,
      lg: 1200,
      lg0: 1200,
      lg1: 1250,
      lg2: 1300,
      lg3: 1350,
      lg4: 1400,
      lg5: 1450,
      xl: 1536,
    },
  },
  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '8px 13px !important',
          lineHeight: '20px',
          fontFamily: 'IranYekanNum !important',
          fontSize: '0.75rem !important',
          borderRadius: '6px !important',
          fontWeight: '400 !important',
        },
        sizeSmall: {
          padding: '5px 9px !important',
        },
        sizeLarge: {
          padding: '7px 21px !important',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: 'IranYekanNum',
          padding: '8px 15px',
          lineHeight: '24px',
          backgroundColor: '#EEEEEE',
          color: '#3C607A',
          fontSize: '0.75rem',
        },
        arrow: {
          color: '#EEEEEE',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: '8px !important',
          maxHeight: '250px !important',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          padding: '16px !important',
          lineHeight: '20px !important',
          fontFamily: 'IranYekanNum !important',
          fontSize: '0.75rem !important',
        },
        button: {
          '&:hover': {
            color: '#222222 !important',
            backgroundColor: '#aadbdd !important',
            borderRadius: '6px !important',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: 'IranYekanNum',
          fontSize: '0.875rem',
        },
      },
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          fontFamily: 'IranYekanNum !important',
          fontSize: '1rem !important',
          fontWeight: '700 !important',
        },
      },
    },

    MuiAlert: {
      styleOverrides: {
        root: {
          fontFamily: 'IranYekanNum !important',
          fontSize: '0.75rem !important',
          fontWeight: '400 !important',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: 'IranYekanNum !important',
          fontSize: '0.875rem !important',
          padding: '0 !important',
          '& .MuiSelect-select': {
            boxSizing: 'border-box',
            backgroundColor: '#ffffff !important',
            height: '44px !important',
            display: 'flex',
            alignItems: 'center',
            paddingRight: '16px !important',
            borderRadius: '6px !important',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 0,
          },
        },
        icon: {
          left: '6px !important',
          right: 'unset',
          color: '#9caebb !important',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          boxSizing: 'border-box',
          border: '1px solid #eeeeee !important',
          borderRadius: '6px !important',
          '&:hover': {
            boxShadow: '0px 0px 0px 2px rgba(117, 196, 200, 0.3)',
          },
          '&::before': {
            border: 'none !important',
          },
          '&::after': {
            border: 'none !important',
          },
        },
        input: {
          borderRadius: '6px !important',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          borderRadius: '6px !important',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '6px !important',
        },
      },
    },
  },
});
